
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16 1C7.726 1 1 7.726 1 16c0 8.274 6.726 15 15 15 8.274 0 15-6.726 15-15 0-8.274-6.726-15-15-15zM3.957 16C3.957 9.362 9.362 3.957 16 3.957c6.638 0 12.043 5.405 12.043 12.043 0 6.638-5.405 12.043-12.043 12.043-6.638 0-12.043-5.405-12.043-12.043zm20.242-5.5a1.479 1.479 0 00-2.09.13l-.001.002-7.72 8.684-4.313-3.452-.004-.004A1.485 1.485 0 008 16.09a1.475 1.475 0 00.229 2.088h.001l5.421 4.338.015.01c.263.195.577.297.897.297.404 0 .812-.163 1.109-.502l8.646-9.727.003-.003a1.477 1.477 0 00-.114-2.084L24.2 10.5z"}})])
          )
        }
      }
    